/*
 * @Author: your name
 * @Date: 2021-06-22 11:19:23
 * @LastEditTime: 2021-06-22 19:23:15
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /HR_FE/src/router/axios.js
 */
/**
 * 全站http配置
 *
 * axios参数说明
 * isSerialize是否开启form表单提交
 * isToken是否需要token
 */
import axios from 'axios'
import Vue from '@/main'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import store from '@/store/'
import router from '@/router'
import { serialize } from '@/util/util'
import { getToken } from '@/util/auth'
import website from '@/config/website'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
import { Base64 } from 'js-base64'
import { defaultProcessOption, defaultEditProcessOption } from '@/config/processOption'
import versionJson from '../../public/pcversion.json'



axios.defaults.timeout = 200000
// 返回其他状态吗
axios.defaults.validateStatus = status => status >= 200 && status <= 500 // 默认的

// 跨域请求，允许保存cookie
axios.defaults.withCredentials = true
// NProgress Configuration
NProgress.configure({
  showSpinner: false,
})
// HTTPrequest拦截
/* eslint-disable no-param-reassign */
axios.interceptors.request.use(config => {
  NProgress.start() // start progress bar
  const meta = (config.meta || {})
  const isToken = meta.isToken === false
  config.headers.Authorization = `Basic ${Base64.encode(`${website.clientId}:${website.clientSecret}`)}`
  config.headers.pcVersion = versionJson.version
  config.headers.from = `aiis-hr-pc`
  if (getToken() && !isToken) {
    config.headers['Blade-Auth'] = `bearer ${getToken()}` // 让每个请求携带token--['Authorization']为自定义key 请根据实际情况自行修改
  } else if (!isToken && store.getters.token && store.getters.aiisToken) {
    config.headers['Blade-Auth'] = `bearer ${store.getters.token}`
  }
  // headers中配置serialize为true开启序列化
  if (config.method === 'post' && meta.isSerialize === true) {
    config.data = serialize(config.data)
  }

  const currentProject = store.getters.currentProject || {}
  config.headers.projectId = currentProject.id
  if (!config.headers.option) {
    const option = defaultProcessOption
    config.headers.option = JSON.stringify(option);
  }
  if (config.url === '/api/mcc-staff/positiverecord/startConfirmationAssessment') {
    config.headers.option = JSON.stringify(defaultEditProcessOption)
  }
  // 如果是文件上传，增加超时时间
  // console.log(config)
  if (config.headers['Content-Type'] === 'multipart/form-data' || config.responseType === 'blob' || config.url.indexOf('export') !== -1) {
    config.timeout = 3600000
  }
  return config
}, error => Promise.reject(error))
/* eslint-enable no-param-reassign */
// HTTPresponse拦截
axios.interceptors.response.use(res => {
  NProgress.done()
  const status = res.data.code || 200
  const statusWhiteList = website.statusWhiteList || []
  // const message = status === 500 ? '服务器内部错误' : (res.data.msg || '未知错误');
  const message = res.data.msg
  // 如果在白名单里则自行catch逻辑处理
  if (statusWhiteList.includes(status)) return Promise.reject(res)
  // 如果是401则跳转到登录页面
  if (status === 401) store.dispatch('FedLogOut').then(() => router.push({ path: '/login' }))
  // 如果是10136代表单点登录里面已经存在的对应的账号信息
  if (status === 10136) {
    return res
  }
  // 如果请求为非200否者默认统一处理
  if (status !== 200) {
    Vue.$toast({
      component: ToastificationContent,
      props: {
        title: 'ERROR',
        icon: 'BellIcon',
        text: message,
        variant: 'danger',
      },
    })
    return Promise.reject(new Error(message))
  }
  return res
}, error => {
  NProgress.done()
  return Promise.reject(new Error(error))
})

export default axios
